import { Tabs } from '@mui/material';
import './tabs.scss';

/** @param {import('@mui/material').TabsProps} param0 */
const CoreTabs = ({ className, ...props }) => (
    <Tabs
        className={`${className || ''} core--tabs`}
        {...props}
    />
);

export default CoreTabs;
